import { CollapseProps, Flex, Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import { ReactNode, useMemo } from "react";
import { formatUAHStandard } from "tm-shared/utils";

import { PrimaryText } from "../Typography";
import {
    StyledTACollapse,
    StyledTACollapseWrapper,
    StyledTATableWrapper,
    StyledTATotalSumText,
} from "./Styled";

export interface UniversalAccordionTableProps<T> {
    data: T[];
    columns: ColumnsType<T>;
    getTotalValue?: (data: T[]) => number;
    title?: string | ReactNode;
}

export const TotalAccordion = <T extends { key: React.Key }>({
    data,
    columns,
    getTotalValue,
    title = "Загальна сума",
}: UniversalAccordionTableProps<T>) => {
    const totalValue = useMemo(
        () => getTotalValue?.(data) ?? 0,
        [data, getTotalValue],
    );

    const items: CollapseProps["items"] = [
        {
            key: "1",
            label: (
                <Flex justify="space-between" align="center">
                    <PrimaryText lineHeight="140%">{title}</PrimaryText>

                    <StyledTATotalSumText>
                        {formatUAHStandard(totalValue)}
                    </StyledTATotalSumText>
                </Flex>
            ),
            children: (
                <StyledTATableWrapper>
                    <Table
                        columns={columns}
                        dataSource={data}
                        pagination={false}
                        bordered
                    />
                </StyledTATableWrapper>
            ),
        },
    ];

    return (
        <StyledTACollapseWrapper>
            <StyledTACollapse items={items} />
        </StyledTACollapseWrapper>
    );
};
